export enum AppLanguage {
    Galician = 'ca',
    Spanish = 'es',
    English = 'en',
}

export const AppLanguages = ['ca', 'es', 'en'];

export const DefaultLanguage = 'ca';